import { PlaygroundStorage } from '../storage/PlaygroundStorage'

type FileHandlesStoreKey = `/${string}`

export class FileHandlesStore {
  private storage = new PlaygroundStorage()

  async entries(): Promise<[FileHandlesStoreKey, FileSystemHandle][]> {
    const database = await this.storage.getDatabase()
    return new Promise<[FileHandlesStoreKey, FileSystemHandle][]>((resolve, reject) => {
      let allHandles: Record<FileHandlesStoreKey, FileSystemHandle> = {}

      const transaction = database.transaction([PlaygroundStorage.fileHandlesStoreName], 'readonly')
      transaction.onerror = (event) => {
        reject((event.target as IDBRequest).error)
      }
      transaction.oncomplete = (event) => {
        resolve(Object.entries(allHandles) as [FileHandlesStoreKey, FileSystemHandle][])
      }

      const store = transaction.objectStore(PlaygroundStorage.fileHandlesStoreName)
      const request = store.getAllKeys()
      request.onsuccess = (event) => {
        const keys = (event.target as IDBRequest<FileHandlesStoreKey[]>).result
        for (const key of keys) {
          store.get(key).onsuccess = (event) => {
            allHandles[key] = (event.target as IDBRequest<FileSystemHandle>).result
          }
        }
      }
    })
  }

  async getHandle(key: FileHandlesStoreKey) {
    const database = await this.storage.getDatabase()
    return new Promise<FileSystemHandle | undefined>((resolve, reject) => {
      let handle: FileSystemHandle | undefined

      const transaction = database.transaction([PlaygroundStorage.fileHandlesStoreName], 'readonly')
      transaction.onerror = (event) => {
        reject((event.target as IDBRequest).error)
      }
      transaction.oncomplete = (event) => {
        resolve(handle)
      }

      const store = transaction.objectStore(PlaygroundStorage.fileHandlesStoreName)
      const request = store.get(key)
      request.onsuccess = (event) => {
        handle = (event.target as IDBRequest<FileSystemHandle>).result
      }
    })
  }

  async addHandle(handle: FileSystemHandle, key: FileHandlesStoreKey) {
    const database = await this.storage.getDatabase()
    return new Promise<void>((resolve, reject) => {
      const transaction = database.transaction([PlaygroundStorage.fileHandlesStoreName], 'readwrite')
      transaction.onerror = (event) => {
        reject((event.target as IDBRequest).error)
      }
      transaction.oncomplete = (event) => {
        resolve()
      }

      const store = transaction.objectStore(PlaygroundStorage.fileHandlesStoreName)
      const request = store.add(handle, key)
      request.onsuccess = (event) => {}
    })
  }

  async removeHandle(key: FileHandlesStoreKey) {
    const database = await this.storage.getDatabase()
    return new Promise<void>((resolve, reject) => {
      const transaction = database.transaction([PlaygroundStorage.fileHandlesStoreName], 'readwrite')
      transaction.onerror = (event) => {
        reject((event.target as IDBRequest).error)
      }
      transaction.oncomplete = (event) => {
        resolve()
      }

      const store = transaction.objectStore(PlaygroundStorage.fileHandlesStoreName)
      const request = store.delete(key)
      request.onsuccess = (event) => {}
    })
  }
}
